import React from 'react';

export const RadioStateOnDefault = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="rgba(144, 160, 175, 0.5)" strokeWidth="6" />
        </svg>
    );
};
